/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionendconfirmtitle3Inputs */

const en_actionendconfirmtitle3 = /** @type {(inputs: Actionendconfirmtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End this action?`)
};

const de_actionendconfirmtitle3 = /** @type {(inputs: Actionendconfirmtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktion beenden?`)
};

/**
* | output |
* | --- |
* | "End this action?" |
*
* @param {Actionendconfirmtitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionendconfirmtitle3 = /** @type {((inputs?: Actionendconfirmtitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionendconfirmtitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionendconfirmtitle3(inputs)
	return de_actionendconfirmtitle3(inputs)
});
export { actionendconfirmtitle3 as "actionEndConfirmTitle" }